import { atom } from "recoil";

export const pendingPlanUpdatedFlagState = atom<boolean>({
  key: "pendingPlanUpdatedFlagState",
  default: false,
});
